import { render } from "./ListeProfesseurPage.vue?vue&type=template&id=3d56ea3b&ts=true"
import script from "./ListeProfesseurPage.vue?vue&type=script&lang=ts"
export * from "./ListeProfesseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__